import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedTooltipComponent } from '@seech/shared-ng';

@Component({
  selector: 'sch-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'hostCompID': "uxNgCompTooltip" }
})
export class TooltipComponent extends SharedTooltipComponent {
  override colorClass = '';
}
